import http from '../http.js';
/**
 * 获取设备属性查询
 * @param params
 * @return {*}
 */
export function MachineAttributeQuerySrv(params) {
  params = params ||''
  let url = '/product/queryMachineAttribute'
  return http.post(url,params)
}
/**
 * 设备列表接口
 * @param params
 * @return {*}
 */
export function MachineListSrv(params) {
  let url = '/product/queryMachineList'
  return http.post(url,params)
}
/**
 * 设备详情接口
 * @param params
 * @return {*}
 */
export function MachineDetailSrv(params) {
  let url = '/product/queryMachineDetail'
  return http.post(url,params)
}
/**
 * 预约参观接口
 * @param params
 * @return {*}
 */
export function AppointmentVisitSrv(params) {
  let url = '/customer/createVisitAppointment'
  return http.post(url,params)
}



// WEBPACK FOOTER //
// ./src/api/productDetail/productList.js